<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">活动内容</div>
            <el-select v-model="activityContentCode" filterable clearable placeholder="请选择活动内容" style="width: 100%">
              <el-option
                  v-for="item in activityContentList"
                  :key="item.activityContentCode"
                  :label="item.name"
                  :value="item.activityContentCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">活动地址</div>
            <el-input v-model="address" placeholder="请输入活动地址"></el-input>
          </el-col>

        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">实践站点</div>
            <el-select v-model="practiceSiteCode" filterable clearable placeholder="请选择实践站点" style="width: 100%">
              <el-option
                  v-for="item in practiceSiteList"
                  :key="item.practiceSiteCode"
                  :label="item.name"
                  :value="item.practiceSiteCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">志愿队伍</div>
            <el-select v-model="volunteerTeamCode" filterable clearable placeholder="请选择志愿队伍" style="width: 100%">
              <el-option
                  v-for="item in volunteerTeamList"
                  :key="item.volunteerTeamCode"
                  :label="item.name"
                  :value="item.volunteerTeamCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">开始时间</div>
            <el-date-picker
                v-model="startTime"
                type="datetime"
                style="width:100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="结束时间">
            </el-date-picker>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">结束时间</div>
            <el-date-picker
                v-model="endTime"
                type="datetime"
                style="width:100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="结束时间">
            </el-date-picker>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">参与人数</div>
            <el-input v-model="elderlyCount" placeholder="请输入参与老人人数"></el-input>
          </el-col>

        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      activityContentList:[],
      activityContentCode:'',

      volunteerTeamList:[],
      volunteerTeamCode:'',

      practiceSiteList:[],
      practiceSiteCode:'',

      address:'',
      startTime:'',
      endTime:'',

      elderlyCount:'',

      activityOrderCode:'',


    }
  },
  methods: {
    init(row){

      this.activityOrderCode = row.activityOrderCode;

      this.activityContentCode = row.activityContentCode;
      this.practiceSiteCode = row.practiceSiteCode;
      this.volunteerTeamCode = row.volunteerTeamCode;

      this.address = row.activityAddress;
      this.startTime = timefilters(row.activityStartTime);
      this.endTime = timefilters(row.activityEndTime);
      this.elderlyCount = row.elderlyCount;


      this.getContentList();

      this.getVolunteerTeamList();
      this.getPracticeSiteList();

    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    isInteger(obj) {
      return parseInt(obj, 10) === obj
    },

    confirm(){

      if(this.activityContentCode === ''){
        this.$message("请选择活动内容");
        return;
      }
      if(this.volunteerTeamCode === ''){
        this.$message("请选择志愿队伍");
        return;
      }
      if(this.practiceSiteCode === ''){
        this.$message("请选择实践站点");
        return;
      }
      if(this.address === ''){
        this.$message("请输入活动地址");
        return;
      }
      if(this.startTime === ''){
        this.$message("请选择活动开始时间");
        return;
      }
      if(this.endTime === ''){
        this.$message("请选择活动结束时间");
        return;
      }

      if(this.elderlyCount == '' || !this.isInteger(this.elderlyCount-0)){
        this.$message("请输入正确的参与人数");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/EditByCommandCenter2',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          volunteerTeamCode:this.volunteerTeamCode,
          practiceSiteCode:this.practiceSiteCode,
          activityContentCode:this.activityContentCode,
          address:this.address,
          startTime:this.startTime,
          endTime:this.endTime,
          elderlyCount:this.elderlyCount,
          activityOrderCode:this.activityOrderCode,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");

        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    getContentList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityContent/ListByComm',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityContentList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getVolunteerTeamList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          applyStatus:2,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.volunteerTeamList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getPracticeSiteList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'PracticeSite/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          applyStatus:2,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.practiceSiteList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

